import { RootState } from '@store/store';
import { userApi } from '@store/api-helpers/userApi';

export const selectUser = (state: RootState) => state.user;
export const selectUserProfile = (state: RootState) => state.user.profile;
export const selectUserFilialeProfile = (state: RootState) => state.user.filialeProfile;
export const selectUserEmail = (state: RootState) => state.user.profile.email;
export const selectUserSettings = (state: RootState) => state.user.settings;
export const selectUserRole = (state: RootState) => state.user.role;
export const selectIsSidebarOpen = (state: RootState) => state.user.settings.sidebar === 'open';
export const selectUserStatus = (state: RootState) => state.user.status;
export const selectCustomerId = (state: RootState) => {
  const profile = state.user.profile;
  return profile?.customer_id ? String(profile.customer_id) : null;
};
export const selectCustomerNumber = (state: RootState) => state.user.profile.customer_number;
export const selectCustomerCardNumber = (state: RootState) => state.user.profile.customer_card_number;
export const selectCustomerCardNumberId = (state: RootState) => state.user.profile.customer_card_id;
export const selectCustomerCardID = (state: RootState) => state.user.profile.customer_card_id;
export const selectUserFeUmsaetze = (state: RootState) => state.user.profile.fe_umsaetze;

export const getUserDataResult = (state: RootState, userId: string) => 
  userApi.endpoints.getUserData.select(userId)(state);

export const getCustomerDataResult = (state: RootState, customerId: string) => 
  userApi.endpoints.getCustomerData.select(customerId)(state);

export const getFilialeDataResult = (state: RootState, filialeId: string) => 
  userApi.endpoints.getFilialeData.select(filialeId)(state);

export const selectUserDataStatus = (state: RootState, userId: string) => {
  const result = getUserDataResult(state, userId);
  if (result.isLoading) return 'loading';
  if (result.isSuccess) return 'succeeded';
  if (result.isError) return 'failed';
  return 'idle';
};

export const selectCustomerDataStatus = (state: RootState, customerId: string) => {
  const result = getCustomerDataResult(state, customerId);
  if (result.isLoading) return 'loading';
  if (result.isSuccess) return 'succeeded';
  if (result.isError) return 'failed';
  return 'idle';
};

export const selectFilialeDataStatus = (state: RootState, filialeId: string) => {
  const result = getFilialeDataResult(state, filialeId);
  if (result.isLoading) return 'loading';
  if (result.isSuccess) return 'succeeded';
  if (result.isError) return 'failed';
  return 'idle';
};

/**
 * Selektor, der prüft, ob das Benutzerprofil vollständig geladen ist
 * @param state - Der Redux-State
 * @returns true, wenn das Profil vollständig geladen ist, sonst false
 */
export const selectIsUserProfileLoaded = (state: RootState) => {
  // Prüfe, ob das Profil existiert und die wichtigsten Daten geladen sind
  const profile = state.user.profile;
  return !!profile && !!profile.customer_id;
};

/**
 * Selektor, der prüft, ob das Filiale-Profil vollständig geladen ist
 * @param state - Der Redux-State  
 * @returns true, wenn das Filiale-Profil vollständig geladen ist, sonst false
 */
export const selectIsFilialeProfileLoaded = (state: RootState) => {
  // Prüfe, ob das Filiale-Profil existiert und die wichtigsten Daten geladen sind
  const filialeProfile = state.user.filialeProfile;
  return !!filialeProfile && !!filialeProfile.filiale_id;
};

/**
 * Selektor für Filiale-ID
 * @param state - Der Redux-State
 * @returns Die Filiale-ID oder null
 */
export const selectFilialeId = (state: RootState) => {
  return state.user.filialeProfile?.filiale_id || null;
};

/**
 * Selektor für Filiale-Titel
 * @param state - Der Redux-State
 * @returns Der Filiale-Titel oder null
 */
export const selectFilialeTitle = (state: RootState) => {
  return state.user.filialeProfile?.title_filiale || null;
};